<template>
  <div>
    <!--BACKGROUOND OPACITY-->
    <div
      ref="backdrop"
      class="fade modal-backdrop"
      style="display: none;"
    ></div>

    <!--MODAL DIALOG-->
    <div
      ref="modal"
      class="modal fade"
      style="display: none;"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="confirm()">
            <!--HEADER-->
            <div class="modal-header">
              <h5
                class="modal-title"
                v-text="data.title"
              ></h5>
              <button
                type="button"
                class="close"
                @click="close(-1)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <!--BODY-->
            <div class="modal-body">
              <form>
                <input
                  v-model="input"
                  type="text"
                  class="form-control"
                />
              </form>
            </div>

            <!--FOOTER-->
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-default"
                @click="close(0)"
                v-html="_trans('Cancel')"
              ></button>
              <button
                type="submit"
                class="btn btn-primary"
                v-html="_trans('Ok')"
              ></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modal from "@configurator/dialogs/_baseModal.vue";
export default {
    mixins: [modal],
    data() {
        return {
            input: ''
        }
    },
    methods: {
        onShow() {
            this.input = '';
        },
        confirm() {
            this.response.input = this.input;
            this.close(1);
            return false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/configurator/dialogs/modalInput.vue